import { UserPermissions } from '../../models/identity/user-permission.model';

export class UpdatePermissions {
    static readonly type = ' [Permissions] Update';
    constructor(public payload: UserPermissions) {}
}
